import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { Text, Checkmark2Icon, TextVariant, MenuItem } from "@flat-ui";
import { PALETTE_VARS } from "@styles/palette-vars";
/**
 * Renders a single selectable item inside the `SphereDropdownSelector` menu.
 *
 * @template T - The value type of the dropdown, constrained to `string | number`.
 */
export function SphereDropdownMenuItem(t0) {
  const $ = _c(24);
  const {
    item,
    currentValue,
    handleChange
  } = t0;
  const isSelected = item.value === currentValue;
  const t1 = `dropdown-item-${item.value}`;
  const t2 = `Select ${item.value}`;
  let t3;
  if ($[0] !== handleChange || $[1] !== item.value) {
    t3 = () => handleChange(item.value);
    $[0] = handleChange;
    $[1] = item.value;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      alignItems: "center",
      gap: "0.75rem",
      width: "100%"
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isSelected ? "primary.main" : "inherit";
  let t7;
  if ($[5] !== item.label || $[6] !== t6) {
    t7 = <Text variant={TextVariant.bodyM} color={t6}>{item.label}</Text>;
    $[5] = item.label;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== isSelected) {
    t8 = isSelected && <Checkmark2Icon data-testid="checkmark-icon" sx={{
      width: "1.25rem",
      height: "1.25rem",
      fill: PALETTE_VARS.primary.main
    }} />;
    $[8] = isSelected;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== item.icon || $[11] !== t7 || $[12] !== t8) {
    t9 = <Stack direction="row" sx={t5}>{t7}{item.icon}{t8}</Stack>;
    $[10] = item.icon;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== item.description) {
    t10 = item.description && <Text variant={TextVariant.bodyS} sx={{
      color: "text.secondary",
      mt: 0.25
    }}>{item.description}</Text>;
    $[14] = item.description;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== isSelected || $[17] !== item.value || $[18] !== t1 || $[19] !== t10 || $[20] !== t2 || $[21] !== t3 || $[22] !== t9) {
    t11 = <MenuItem key={item.value} value={item.value} data-testid={t1} aria-label={t2} selected={isSelected} onClick={t3} sx={t4}>{t9}{t10}</MenuItem>;
    $[16] = isSelected;
    $[17] = item.value;
    $[18] = t1;
    $[19] = t10;
    $[20] = t2;
    $[21] = t3;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}